import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import { SearchCriteria, SortModel } from '@boels/models';
import { ActivatedRoute, Router } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { first, from, tap } from 'rxjs';
import { WindowRef } from '@boels/helpers';
import { faSort } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'boels-sorting',
  imports: [NgSelectModule, FormsModule, FontAwesomeModule, TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['productList'],
    },
  ],
  templateUrl: './sorting.component.html',
  styleUrls: ['./sorting.component.scss'],
})
export class SortingComponent implements OnChanges {
  protected router = inject(Router);
  protected activatedRoute = inject(ActivatedRoute);
  protected windowRef = inject(WindowRef);

  selectedOption: string | undefined;

  @Input()
  sortOptions: SortModel[] | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['sortOptions']) {
      this.selectedOption = this.sortOptions?.find(
        (sortModel: SortModel) => sortModel.selected,
      )?.code;
    }
  }

  sort(sortCode: string): void {
    this.navigate({ sortCode });
  }

  private navigate(queryParams: SearchCriteria): void {
    if (this.windowRef.isBrowser()) {
      const currentScrollHeight = this.windowRef.nativeWindow?.scrollY;
      from(
        this.router.navigate([], {
          queryParams,
          queryParamsHandling: 'merge',
          relativeTo: this.activatedRoute,
        }),
      )
        .pipe(
          first(),
          tap(() =>
            this.windowRef.nativeWindow?.scrollTo({ top: currentScrollHeight }),
          ),
        )
        .subscribe();
    }
  }

  protected readonly faSort = faSort;
}
